import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Container } from '@chakra-ui/react';

export const Description = ({ updateValue, value, disabled }) => (
  <Container maxW="992px">
    <div className="row">
      <div className="col-12">
        <p className="fw-bold text-uppercase mb-2">Descrição</p>{' '}
      </div>
    </div>
    <ReactQuill
      theme="snow"
      value={value}
      placeholder={'Digite a descrição do produto'}
      readOnly={disabled}
      onChange={value => updateValue('body_html', value)}
    />
  </Container>
);
